import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('DNA_HELIX', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const h = 100 * progress;
  for (let i = 0; i < 20; i++) {
    const yOff = (i / 20) * h - h / 2;
    const w = 20 * Math.sin(i * 0.5 + elapsed * 0.01);
    ctx.fillStyle = determineColor(i, 20);
    ctx.globalAlpha = 1 - progress;
    ctx.beginPath(); ctx.arc(e.pos.x + w, e.pos.y + yOff, 3, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.arc(e.pos.x - w, e.pos.y + yOff, 3, 0, Math.PI * 2); ctx.fill();
  }
});
